"use strict";
"use client";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { Avatar } from '@ark-ui/react/avatar';
export { AvatarContext as Context } from '@ark-ui/react/avatar';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';
import { createSlotRecipeContext } from './utils/create-slot-recipe-context.mjs';

const avatarRecipe = tv({
  slots: withSlotScopeClasses("avatar", {
    root: "rounded-full shrink-0 overflow-hidden",
    fallback: [
      "flex items-center justify-center h-[inherit]",
      "bg-bg-subtle text-fg-default border rounded-full font-semibold",
      "[&[hidden]]:hidden"
    ],
    image: "object-cover"
  }),
  variants: {
    size: {
      xs: {
        root: "h-8 w-8",
        image: "h-8 w-8",
        fallback: "text-xs leading-[1.125rem] [&_svg]:w-4 [&_svg]:h-4"
      },
      sm: {
        root: "h-9 w-9",
        image: "h-9 w-9",
        fallback: "text-sm leading-5 [&_svg]:w-4 [&_svg]:h-4"
      },
      md: {
        root: "h-10 w-10",
        image: "h-10 w-10",
        fallback: "text-base leading-6 [&_svg]:w-5 [&_svg]:h-5"
      },
      lg: {
        root: "h-11 w-11",
        image: "h-11 w-11",
        fallback: "text-lg leading-7 [&_svg]:w-6 [&_svg]:h-6"
      },
      xl: {
        root: "h-12 w-12",
        image: "h-12 w-12",
        fallback: "text-xl leading-[1.875rem] [&_svg]:w-7 [&_svg]:h-7"
      },
      "2xl": {
        root: "h-16 w-16",
        image: "h-16 w-16",
        fallback: "text-2xl leading-8 [&_svg]:w-8 [&_svg]:h-8"
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});
const { withProvider, withContext } = createSlotRecipeContext(avatarRecipe);
withProvider(Avatar.RootProvider, "root");
const Root = withProvider(
  Avatar.Root,
  "root"
);
const Fallback = withContext(
  Avatar.Fallback,
  "fallback"
);
const Image = withContext(Avatar.Image, "image");

export { Fallback, Image, Root };
